import React, { Component } from 'react'
import { Table, DatePicker, Button, Select, Input, message } from 'antd'
import moment from 'moment'
import { OK } from '../../CheckOutAdvManage/constants'
import NineAndZeroRadio from '../../../components/nineAndZeroRadio'

const { RangePicker } = DatePicker

const TYPE_MAP = { 0: '回合计费', 5: '套餐', 7: '团购', 8: '卡券', 9: '预订', 10: '定时' }
const TYPE_OPTIONS = [
  { label: '全部', value: '' },
  { label: '回合计费', value: 0 }, { label: '套餐', value: 5 }, { label: '团购', value: 7 },
  { label: '卡券', value: 8 }, { label: '预订', value: 9 }, { label: '定时', value: 10 },
]

const columns = [
  { title: '桌台编号', dataIndex: 'tableId', key: 'tableId' },
  { title: '桌台名称', dataIndex: 'tablename', key: 'tablename' },
  { title: '消费类型', dataIndex: 'type', key: 'type', render: (v) => TYPE_MAP[v] || v },
  { title: '开始时间', dataIndex: 'startTime', key: 'startTime', render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : '' },
  { title: '结束时间', dataIndex: 'endTime', key: 'endTime', render: (v) => v ? moment(v).format('YYYY-MM-DD HH:mm') : '' },
  { title: '时长(h)', dataIndex: 'duration', key: 'duration' },
  { title: '金额(元)', dataIndex: 'totalAmount', key: 'totalAmount', render: (v) => v ? (v / 100).toFixed(2) : '0.00' },
  { title: '会员账号', dataIndex: 'account', key: 'account' },
  { title: '流水号', dataIndex: 'serialNumber', key: 'serialNumber' },
  { title: '结账日期', dataIndex: 'settleDate', key: 'settleDate' },
]

class DetailTab extends Component {
  state = {
    start_time: '', end_time: '', type: '', tableName: '',
    statisticType: 2, page: 1, size: 20, loading: false, exportLoading: false,
  }

  onDateChange = (_, dateString) => {
    this.setState({ start_time: dateString[0], end_time: dateString[1] })
  }

  onTypeEvent = (type) => {
    this.setState({ statisticType: type })
  }

  fetch = (p = {}) => {
    const { start_time, end_time, type, tableName, statisticType, page, size } = { ...this.state, ...p }
    if (!start_time || !end_time) { message.info('请选择时间范围'); return }
    this.setState({ loading: true, ...p })
    this.props.onFetchDetail({ startDate: start_time, endDate: end_time, type, tableName, statisticType, page, size })
      .then(() => this.setState({ loading: false }))
  }

  onExport = () => {
    const { start_time, end_time, type, tableName, statisticType } = this.state
    if (!start_time || !end_time) { message.info('请选择时间范围'); return }
    this.setState({ exportLoading: true })
    this.props.onExport({ startDate: start_time, endDate: end_time, type, tableName, statisticType })
      .then(() => this.setState({ exportLoading: false }))
      .catch(() => { this.setState({ exportLoading: false }); message.error('导出失败') })
  }

  disabledDate = (current) => current && current > moment().endOf('day')

  render() {
    const { list } = this.props
    const { page, size, loading, exportLoading } = this.state
    const respData = list && list.status === OK ? list.data : {}
    return (
      <div>
        <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
          <RangePicker disabledDate={this.disabledDate} format="YYYY-MM-DD" placeholder={['开始日期', '结束日期']} onChange={this.onDateChange} />
          <NineAndZeroRadio typeEvent={this.onTypeEvent} />
          <Select placeholder="消费类型" style={{ width: 120 }} defaultValue="" onChange={(val) => this.setState({ type: val })}>
            {TYPE_OPTIONS.map((opt) => <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>)}
          </Select>
          <Input placeholder="桌台名称" allowClear style={{ width: 150 }} onChange={(e) => this.setState({ tableName: e.target.value })} />
          <Button type="primary" onClick={() => this.fetch({ page: 1 })} loading={loading}>查询</Button>
          <Button loading={exportLoading} onClick={this.onExport}>导出</Button>
        </div>
        <Table
          rowKey="id" bordered loading={loading} columns={columns}
          dataSource={respData.values || []}
          pagination={{
            current: page, pageSize: size, total: respData.total || 0,
            showSizeChanger: true, showTotal: (t) => `共 ${t} 条`,
            onChange: (p, s) => this.fetch({ page: p, size: s }),
          }}
          scroll={{ x: 'max-content' }}
        />
      </div>
    )
  }
}

export default DetailTab



// WEBPACK FOOTER //
// ./src/containers/TableUsageStatistics/component/DetailTab.js